import { formatQueryParams } from '@zorro/common-utils';
import { Link } from '@zorro/design-system/v2/Link';
import { Text } from '@zorro/web/design-system';
import { useImpersonation } from '@zorro/web/ui-utils';

type Props = {
  filesPageUrl: string;
};

export const FilesPageDocumentsNote = ({ filesPageUrl }: Props) => {
  const { impersonatedEmployeeId } = useImpersonation();

  return (
    <Text size="sm">
      If you haven't provided these documents yet, you can upload them anytime
      from your{' '}
      <Link
        href={formatQueryParams(filesPageUrl, { impersonatedEmployeeId })}
        variant="secondary"
        fw={600}
      >
        Files page
      </Link>{' '}
      in Zorro, or email them to{' '}
      <Link href="mailto:support@myzorro.co" variant="secondary" fw={600}>
        support@myzorro.co
      </Link>
      .
    </Text>
  );
};
